import { Popover, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { RowGroupingColumnSelect } from './RowGroupingColumnSelect'

interface Props {
  open: boolean
  onClose: () => void
  anchorElement: HTMLButtonElement | null
}

export const RowGroupingPopover: React.FC<Props> = ({ open, onClose, anchorElement }) => {
  const { t } = useTranslation('requests')

  return (
    <Popover
      anchorEl={anchorElement}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
    >
      <Stack sx={{ minWidth: '440px', p: 6, px: 4 }}>
        <Stack sx={{ pb: 2 }}>
          <Typography variant="HeaderSubtitleMediumRegular" color="#6B6C7E">
            {t('group-by.title')}
          </Typography>
        </Stack>
        <Stack>
          <RowGroupingColumnSelect />
        </Stack>
      </Stack>
    </Popover>
  )
}
